import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

const mapStyles = {
	width: '85%',
	height: '85%'
};

export class MapContainer extends Component {
	state = {
		activeMarker: {}, //Shows the active marker upon click
		selectedPlace: {} //Shows the infoWindow to the selected place upon a marker
	};
	onMarkerClick = (props, marker, e) =>
		this.setState({
			selectedPlace: props,
			activeMarker: marker,
			showingInfoWindow: true
		});

	onClose = (props) => {
		if (this.state.showingInfoWindow) {
			this.setState({
				showingInfoWindow: false,
				activeMarker: null
			});
		}
	};

	render() {
		return (
			<Map
				google={this.props.google}
				zoom={15}
				style={mapStyles}
				initialCenter={{
					lat: 48.218048,
					lng: 16.305005
				}}
			>
				<Marker
					onClick={this.onMarkerClick}
					title={'Psychotherapeutische Praxis'}
					position={{ lat: 48.2178764, lng: 16.3027549 }}
				/>
			</Map>
		);
	}
}

export default GoogleApiWrapper({
	apiKey: 'AIzaSyDG1OtaY2Q3f_-JAuCpZ0pJnakufEEQwsk'
})(MapContainer);
